import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, PlusCircle, Mail, User } from 'lucide-react';
import { Badge } from '../ui/badge';
import { FileText, ClipboardList } from 'lucide-react';

const BottomNav = ({ data }) => {
  const { user, unreadMessages, isActive, handleAddButtonClick, showAddMenu, setShowAddMenu, handleAddOption } = data;

  const bottomNavItems = [
    { href: '/', label: 'Home', icon: Home },
    { href: '/search', label: 'Discover', icon: Search },
    { href: '#add', label: 'Post', icon: PlusCircle, highlight: true, isAddButton: true },
    { href: '/messages', label: 'Messages', icon: Mail },
    { href: user ? '/profile' : '/login', label: 'Profile', icon: User },
  ];

  return (
    <>
      <nav className="bottom-nav" data-testid="bottom-nav">
        <div className="flex items-center justify-around">
          {bottomNavItems.map((item) => (
            item.isAddButton ? (
              <button key="add-button" onClick={handleAddButtonClick} className="bottom-nav-item flex-1 relative" data-testid="bottom-nav-add">
                <div className="absolute -top-4 bg-orange-700 p-3 rounded-full shadow-lg"><item.icon className="w-6 h-6 text-white" /></div>
              </button>
            ) : (
              <Link key={item.href} to={item.href} className={`bottom-nav-item flex-1 ${isActive(item.href) ? 'active' : ''}`} data-testid={`bottom-nav-${item.label.toLowerCase().replace(' ', '-')}`}>
                <item.icon className="w-5 h-5" />
                <span className="text-[10px] mt-1">{item.label}</span>
                {item.label === 'Messages' && unreadMessages > 0 && (
                  <Badge className="absolute -top-1 right-1/4 h-4 w-4 flex items-center justify-center p-0 text-[8px] bg-orange-700">{unreadMessages}</Badge>
                )}
              </Link>
            )
          ))}
        </div>
      </nav>

      {/* Add Menu Modal */}
      {showAddMenu && (
        <div className="fixed inset-0 z-[100] flex items-end justify-center md:items-center">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setShowAddMenu(false)} />
          <div className="relative bg-white rounded-t-3xl md:rounded-2xl w-full md:max-w-sm p-6 pb-8 animate-in slide-in-from-bottom duration-300">
            <div className="w-12 h-1 bg-slate-300 rounded-full mx-auto mb-6 md:hidden" />
            <h3 className="text-lg font-semibold text-center mb-6">What would you like to do?</h3>
            <div className="grid grid-cols-2 gap-4">
              <button onClick={() => handleAddOption('listing')} className="flex flex-col items-center gap-3 p-6 bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl border-2 border-emerald-200 hover:border-emerald-400 transition-all" data-testid="add-listing-option">
                <div className="w-14 h-14 bg-emerald-600 rounded-full flex items-center justify-center"><FileText className="w-7 h-7 text-white" /></div>
                <span className="font-medium text-emerald-800">Post Listing</span>
                <span className="text-xs text-emerald-600 text-center">Sell items, property or vehicles</span>
              </button>
              <button onClick={() => handleAddOption('request')} className="flex flex-col items-center gap-3 p-6 bg-gradient-to-br from-emerald-50 to-blue-100 rounded-2xl border-2 border-emerald-200 hover:border-blue-400 transition-all" data-testid="add-request-option">
                <div className="w-14 h-14 bg-emerald-700 rounded-full flex items-center justify-center"><ClipboardList className="w-7 h-7 text-white" /></div>
                <span className="font-medium text-emerald-900">Request a Service</span>
                <span className="text-xs text-emerald-700 text-center">Building, cleaning, repairs</span>
              </button>
            </div>
            <button onClick={() => setShowAddMenu(false)} className="w-full mt-4 py-3 text-slate-500 hover:text-slate-700 transition-colors">Cancel</button>
          </div>
        </div>
      )}
    </>
  );
};

export default BottomNav;
